import { css } from "@emotion/css";
import { useTranslation } from "react-i18next";

import { useStyles } from "@/hooks/useStyles.ts";
import { userFormattedName } from "@/models/UserModel.ts";
import { Queries } from "@/queries/Queries.ts";
import { CardFooter } from "@/uiKit/atoms/CardFooter.tsx";
import { CardHeader } from "@/uiKit/atoms/CardHeader.tsx";
import { ColoredCard } from "@/uiKit/atoms/ColoredCard.tsx";
import { ProfilePicture } from "@/uiKit/atoms/ProfilePicture.tsx";

import { Button } from "../../atoms/Button";

type NurseNoticeBannerProps = {
  patientId: string;
};

export const NurseNoticeBanner = ({ patientId }: NurseNoticeBannerProps) => {
  const { t } = useTranslation();
  const mitigateMutation = Queries.observations.useMitigateNotice();
  const styles = useStyles(makeStyles);
  const notice = Queries.practitioner.useNurseNotice(patientId);

  if (!notice) {
    return null;
  }

  return (
    <ColoredCard id="nurse-notice-banner" square border color="blue" className={styles.container}>
      <CardHeader
        startIcon={
          notice.nurseFirstName &&
          notice.nurseLastName && (
            <ProfilePicture
              id="nurse-notice-banner-nurse-avatar"
              src={notice.nurseProfilePicture?.url}
              firstName={notice.nurseFirstName}
              lastName={notice.nurseLastName}
              colorVariant="secondary"
              size="medium"
              tooltip={userFormattedName(notice.nurseLastName, notice.nurseFirstName)}
            />
          )
        }
        variant="banner"
        title={t("patientNavigation.notice.banner")}
      />
      <CardFooter position="start">
        <Button
          id="mitigate-notice-button"
          pending={mitigateMutation.isPending}
          variant="contained"
          data-action="medical-file.notice.dismiss"
          onClick={() =>
            mitigateMutation.mutate({
              patient_id: notice.patientId,
              id: notice.id,
            })
          }
        >
          {t("patientNavigation.notice.mitigateNotify")}
        </Button>
      </CardFooter>
    </ColoredCard>
  );
};

const makeStyles = () => ({
  container: css({}),
});
